import { render, staticRenderFns } from "./search-box-archive.vue?vue&type=template&id=fce8202e&scoped=true"
import script from "./search-box-archive.vue?vue&type=script&lang=js"
export * from "./search-box-archive.vue?vue&type=script&lang=js"
import style0 from "./search-box-archive.vue?vue&type=style&index=0&id=fce8202e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce8202e",
  null
  
)

export default component.exports